import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { FaHome, FaUser, FaUserFriends, FaDice, FaShoppingCart, FaChartLine } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './Header';
import Footer from './Footer';
import './Nav.css';
import './Portal.css';

const Portal = () => {
  const location = useLocation();

  const pageVariants = {
    initial: {
      opacity: 0,
      x: "100%",
    },
    in: {
      opacity: 1,
      x: 0,
    },
    out: {
      opacity: 0,
      x: "-100%",
    }
  };

  const pageTransition = {
    type: "tween",
    ease: "easeInOut",
    duration: 0.3
  };

  return (
    <>
      <div className="canvas"></div>
      <div className="portal-layout">
        <Header />
        <nav className="portal-nav">
          <Link to="/portal" className={location.pathname === '/portal' ? 'nav-icon active' : 'nav-icon'}><FaHome /></Link>
          <Link to="/portal/profile" className={location.pathname.startsWith('/portal/profile') ? 'nav-icon active' : 'nav-icon'}><FaUser /></Link>
          <Link to="/portal/social" className={location.pathname.startsWith('/portal/social') ? 'nav-icon active' : 'nav-icon'}><FaUserFriends /></Link>
          <Link to="/portal/casino" className={location.pathname.startsWith('/portal/casino') ? 'nav-icon active' : 'nav-icon'}><FaDice /></Link>
          <Link to="/portal/market" className={location.pathname.startsWith('/portal/market') ? 'nav-icon active' : 'nav-icon'}><FaChartLine /></Link>
          <Link to="/portal/shop" className={location.pathname.startsWith('/portal/shop') ? 'nav-icon active' : 'nav-icon'}><FaShoppingCart /></Link>
        </nav>
        <main className="portal-main">
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial="initial"
              animate="in"
              exit="out"
              variants={pageVariants}
              transition={pageTransition}
              className="portal-section"
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Portal;